import { useCallback, useEffect, useState } from "react";
import { Tooltip } from "react-leaflet";
import classNames from "classnames";

import disableLeafletMouseEvents from "../Utils/disableLeafletMouseEvents";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";

const MapTooltip = ({ showOnMobile = false, ...props }) => {
  const { interactive, tooltipInnerStyle, children } = props;

  const { isDesktop } = useResponsiveFlag();
  const [forceContentWidth, setForceContentWidth] = useState(false);

  const className = classNames("map-tooltip", props.className, {
    "map-tooltip-fixed-width": forceContentWidth,
    "leaflet-clickable": interactive
  });

  const [tooltip, setTooltip] = useState();
  const [tooltipInner, setTooltipInner] = useState();

  const updateContentSize = useCallback(() => {
    if (!tooltip || !tooltipInner) return;
    const tooltipMaxWidth = isDesktop ? 350 : window.innerWidth;

    if (tooltipInner.clientWidth > tooltipMaxWidth) {
      setForceContentWidth(true);
    }
  }, [isDesktop, tooltip, tooltipInner]);

  const setTooltipRef = useCallback(
    tooltip => {
      setTooltip(tooltip);
      updateContentSize();
    },
    [updateContentSize]
  );

  const setTooltipInnerRef = useCallback(
    tooltipInner => {
      setTooltipInner(tooltipInner);
      updateContentSize();
      if (interactive) disableLeafletMouseEvents(tooltipInner);
    },
    [interactive, updateContentSize]
  );

  useEffect(() => {
    window.addEventListener("newContentLoaded", updateContentSize);
    return () => window.removeEventListener("newContentLoaded", updateContentSize);
  }, [updateContentSize]);

  if (!isDesktop && !showOnMobile) return null;

  return (
    <Tooltip
      {...props}
      ref={setTooltipRef}
      className={className}
      interactive={interactive}
    >
      <div
        className="tooltip-inner mw-100"
        style={tooltipInnerStyle}
        ref={setTooltipInnerRef}
      >
        {tooltipInner && children}
      </div>
    </Tooltip>
  );
};

export default MapTooltip;
